import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
// import WalletBalanceCard from '../../Components/Wallet/WalletBalanceCard'
import BalanceCard from '../../Components/Wallet/BalanceCard'
import TransactionSection from '../../Components/Wallet/TransactionSection'
import AddFundsModal from '../../Components/Wallet/AddFundsModal'
import SendMoneyModal from '../../Components/Wallet/SendMoneyModal'
import WithdrawalModal from '../../Components/Wallet/WithdrawalModal'
import ConvertModal from '../../Components/Wallet/ConvertModal'
import TransactionDetailsModal from '../../Components/Wallet/TransactionDetailsModal'
import SecurityVerificationModal from '../../Components/Wallet/SecurityVerificationModal'
import WalletSkeleton from '../../Components/Wallet/WalletSkeleton'
import { useWalletDetails } from '../../hooks/api/useWallet'
import { useNavigate } from 'react-router-dom'
import SuccessModal from '../../Components/ModalComponents/SuccessModal'

// const exampleResponseFromWalletDetails = {
//   "coinBalance": 0,
//   "withdrawableBalance": 0,
//   "walletBalance": 0,
//   "totalSpendableCoins": 0,
//   "withdrawableBalanceInDollars": 0,
//   "conversionRate": 0,
//   "minCoinsForConversion": 0,
//   "minWithdrawalAmount": 0,
//   "maxWithdrawalAmount": 0
// }

function Wallet() {
  const navigate = useNavigate()
  const { data, isLoading } = useWalletDetails()
//   const [currency] = useState('USD')

  // Use hook data or fallback to defaults
  const walletBalance = data?.walletBalance || 0
  const bdTotalSpendableBalance = data?.totalSpendableCoins || 0
  const bdCoinBalance = data?.coinBalance || 0
  const withdrawableBalance = data?.withdrawableBalance || 0

  // Converted wallet balance based on currency
//   const convertedBalance = useMemo(() => {
//     const EXCHANGE_RATES = {
//       USD: 1,
//       EUR: 0.92,
//       CAD: 1.35,
//       NGN: 1500,
//       GBP: 0.78,
//       JPY: 150
//     }

//     return walletBalance * EXCHANGE_RATES[currency]
//   }, [walletBalance, currency])

  // Modal states
  const [activeModal, setActiveModal] = useState(null)
  const [sendType, setSendType] = useState('money')
  const [selectedTransaction, setSelectedTransaction] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')
  const [pendingAction, setPendingAction] = useState(null)

  const openModal = (modalName) => setActiveModal(modalName)
  const closeModal = () => setActiveModal(null)

//   const handleSendFunds = () => {
//     setSendType('money')
//     openModal('sendMoney')
//   }

  const handleSendCoins = () => {
    setSendType('coins')
    openModal('sendMoney')
  }

  const handleSendComplete = () => {
    closeModal()
    setPendingAction({ message: 'Funds transferred' })
    openModal('security')
  }

  const handleWithdrawalComplete = () => {
    closeModal()
    setPendingAction({ message: 'Your Withdrawal is being processed' })
    openModal('security')
  }

  const handleConvertComplete = () => {
    closeModal()
    setSuccessMessage('Conversion Successful')
    openModal('success')
  }

  const handleCoinTransferSuccess = () => {
    closeModal()
    setSuccessMessage('Coins transferred')
    openModal('success')
  }

  const handleVerificationSuccess = () => {
    closeModal()
    if (pendingAction) {
      setSuccessMessage(pendingAction.message)
      setPendingAction(null)
      openModal('success')
    }
  }

  const handleTransactionClick = (tx) => {
    setSelectedTransaction(tx)
    openModal('transactionDetails')
  }

  // Show skeleton loader while fetching data
  if (isLoading && !data) {
    return <WalletSkeleton />
  }

  return (
    <div className="min-h-screen w-full text-white p-4">
      <div className="">
        <h1 className="text-2xl xl:text-4xl font-bold mb-6">Wallet</h1>

        {/* Wallet Balance Card with dynamic currency */}
        {/* <WalletBalanceCard
          balance={convertedBalance}
          currency={currency}
          onCurrencyChange={setCurrency}
        /> */}

        <div className="space-y-4 mt-4">
          <BalanceCard
            title="Current Wallet Balance"
            balance={walletBalance}
            currencySymbol="$"
            actions={[
              // { icon: 'wallet', label: 'Add Funds', onClick: () => openModal('addFunds') },
              // { icon: 'send', label: 'Send Funds', onClick: handleSendFunds },
              { icon: 'landmark', label: 'Withdrawal', onClick: () => openModal('withdrawal') }
            ]}
          />

          <BalanceCard
            title="BD Coin Balance"
            balance={bdTotalSpendableBalance}
            isCoin
            subValue={`$${(bdTotalSpendableBalance * (data?.conversionRate || 0.01)).toFixed(2)}`}
            actions={[
                { icon: 'shopping-cart', label: 'Buy BD Coins', onClick: () => { navigate("bd-coins") } },
              { icon: 'send', label: 'Send BD Coins', onClick: handleSendCoins },
              { icon: 'arrows-right-left', label: 'Convert', onClick: () => openModal('convert') }
            ]}
          />
        </div>

        <TransactionSection onTransactionClick={handleTransactionClick} />
      </div>

      <AnimatePresence>
        {activeModal === 'addFunds' && <AddFundsModal onClose={closeModal} />}
        {activeModal === 'sendMoney' && (
          <SendMoneyModal
            type={sendType}
            balance={sendType === 'coins' ? bdCoinBalance : walletBalance}
            onClose={closeModal}
            onComplete={handleSendComplete}
            onSuccess={handleCoinTransferSuccess}
          />
        )}
        {activeModal === 'withdrawal' && (
          <WithdrawalModal
            balance={walletBalance}
            onClose={closeModal}
            onComplete={handleWithdrawalComplete}
            minAmount={data?.minWithdrawalAmount}
            maxAmount={data?.maxWithdrawalAmount}
          />
        )}
        {activeModal === 'convert' && (
          <ConvertModal
            withdrawableBalance={withdrawableBalance}
            coinBalance={bdCoinBalance}
            onClose={closeModal}
            onComplete={handleConvertComplete}
            conversionRate={data?.conversionRate}
            minCoinsRequired={data?.minCoinsForConversion}
          />
        )}
        {activeModal === 'transactionDetails' && selectedTransaction && (
          <TransactionDetailsModal
            transaction={selectedTransaction}
            onClose={closeModal}
          />
        )}
        {activeModal === 'security' && (
          <SecurityVerificationModal
            onClose={closeModal}
            onSuccess={handleVerificationSuccess}
          />
        )}
        {activeModal === 'success' && (
          <SuccessModal message={successMessage} onClose={closeModal} />
        )}
      </AnimatePresence>
    </div>
  )
}

export default Wallet
